/* Cosmelia – Preis- und Klarna-Anzeige folgt dem gewählten Bundle (Rapid Bundle). Fällt still zurück, wenn nichts gefunden wird. */
(function () {
  var MONEY = /(\d{1,3}(?:[.\s]\d{3})*,\d{2})\s?€|€\s?(\d{1,3}(?:[.\s]\d{3})*,\d{2})/g;

  function parse(str) {
    return parseFloat(String(str).replace(/[.\s]/g, '').replace(',', '.'));
  }
  function fmt(n) {
    return n.toFixed(2).replace('.', ',') + ' €';
  }
  function prices(el) {
    var out = [], m, txt = (el.innerText || el.textContent || '');
    MONEY.lastIndex = 0;
    while ((m = MONEY.exec(txt))) out.push(parse(m[1] || m[2]));
    return out.filter(function (n) { return n > 0; });
  }
  function update(head, list) {
    if (!head || !list.length) return;
    var price = Math.min.apply(null, list);
    var compare = Math.max.apply(null, list);
    var p = head.querySelector('[data-cz-price]');
    var c = head.querySelector('[data-cz-compare]');
    var o = head.querySelector('[data-cz-off]');
    var k = head.querySelectorAll('[data-cz-klarna]');
    if (p) p.textContent = fmt(price);
    if (c) { c.textContent = compare > price ? fmt(compare) : ''; }
    if (o) { o.textContent = compare > price ? '−' + Math.round((1 - price / compare) * 100) + ' %' : ''; }
    for (var i = 0; i < k.length; i++) k[i].textContent = fmt(Math.ceil(price / 3 * 100) / 100);
  }
  function findSelected(scope) {
    var r = scope.querySelector('input[type="radio"]:checked');
    if (r) return r.closest('label, li, [class*="bundle"], [class*="option"], [class*="tier"]') || r.parentElement;
    return scope.querySelector('[class*="bundle"] [class*="selected"], [class*="bundle"] [class*="active"], [class*="bundle"] [aria-checked="true"], [class*="bundle"] [aria-pressed="true"]');
  }
  function refresh(evtTarget) {
    var heads = document.querySelectorAll('.cz-pdp[data-cz-dynamic]');
    heads.forEach(function (head) {
      var sec = head.closest('section, .shopify-section');
      if (sec && sec.querySelector('[data-cz-bundle]')) return;
      var scope = head.closest('.product-details, product-form, form, section') || document;
      var sel = findSelected(scope.closest('section') || scope);
      if (sel) update(head, prices(sel));
    });
  }
  ['change', 'click'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (!e.target.closest || e.target.closest('[data-cz-bundle]')) return;
      if (e.target.closest('[class*="bundle"], [id*="bundle"], [class*="rapid"], [id*="rapid"], input[type="radio"]')) {
        setTimeout(refresh, 60);
      }
    }, true);
  });
  document.addEventListener('DOMContentLoaded', function () { setTimeout(refresh, 800); setTimeout(refresh, 2500); });
})();

/* Cosmelia – eigenes Bundle (Shampoo, Kapseln, Gummies): setzt die Menge im Produktformular */
(function () {
  function apply(bundle) {
    var r = bundle.querySelector('input[type="radio"]:checked');
    if (!r) return;
    var section = bundle.closest('.shopify-section') || document;
    var qty = section.querySelector('form[action*="/cart/add"] input[name="quantity"], input[name="quantity"]');
    if (qty) { qty.value = r.value; qty.dispatchEvent(new Event('change', { bubbles: true })); qty.dispatchEvent(new Event('input', { bubbles: true })); }
    var head = section.querySelector('.cz-pdp[data-cz-dynamic]');
    if (head) {
      var set = function (sel, v) { var el = head.querySelector(sel); if (el) el.textContent = v; };
      set('[data-cz-price]', r.dataset.price);
      set('[data-cz-compare]', r.dataset.compare || '');
      set('[data-cz-off]', r.dataset.off || '');
      head.querySelectorAll('[data-cz-klarna]').forEach(function (k) { k.textContent = r.dataset.klarna; });
    }
    var prow = bundle.querySelector('[data-cz-giftp-row]');
    if (prow) { var gv = r.dataset.giftVariant; prow.hidden = !gv; if (gv) { prow.querySelector('[data-cz-giftp]').textContent = r.dataset.giftTitle || ''; prow.querySelector('[data-cz-giftp-value]').textContent = r.dataset.giftValue || ''; } }
    var row = bundle.querySelector('[data-cz-gift-row]');
    if (row) { var g = r.dataset.gift || ''; row.hidden = !g; var t = row.querySelector('[data-cz-gift]'); if (t) t.textContent = g; }
  }
  function init() { document.querySelectorAll('[data-cz-bundle]').forEach(apply); }
  document.addEventListener('change', function (e) {
    var b = e.target.closest && e.target.closest('[data-cz-bundle]');
    if (b) apply(b);
  });
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  /* Formular kann den Wert nach dem Laden zurücksetzen – vor dem Absenden erneut anwenden */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.action || f.action.indexOf('/cart/add') === -1) return;
    var sec = f.closest('.shopify-section'); var b = sec && sec.querySelector('[data-cz-bundle]');
    if (b) { var r = b.querySelector('input:checked'); var q = f.querySelector('input[name="quantity"]'); if (r && q) q.value = r.value; }
  }, true);
})();

/* Cosmelia – Geschenkprodukt (z. B. Shampoo bei 2+2) nach erfolgreichem Hinzufügen automatisch ergänzen */
(function () {
  var pending = null;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[ref="addToCartButton"], button[name="add"]');
    if (!btn) return;
    var sec = btn.closest('.shopify-section'); var b = sec && sec.querySelector('[data-cz-bundle]');
    var r = b && b.querySelector('input:checked');
    pending = r && r.dataset.giftVariant ? { id: Number(r.dataset.giftVariant), min: Number(r.dataset.giftMin || 1), pid: Number(r.dataset.giftFor || 0), at: Date.now() } : null;
  }, true);
  document.addEventListener('cart:update', function (e) {
    var d = e.detail || {};
    if (!pending || d.sourceId === 'cz-gift' || (d.data && d.data.didError)) return;
    if (Date.now() - pending.at > 15000) { pending = null; return; }
    var gift = pending; pending = null;
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      var has = cart.items.some(function (it) { return it.variant_id === gift.id; });
      if (has) return cart;
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: gift.id, quantity: 1, properties: { _cz_gift_for: String(gift.pid), _cz_gift_min: String(gift.min) } }] }) })
        .then(function () { return fetch('/cart.js', { cache: 'no-store' }); }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      if (!cart) return;
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: cart, sourceId: 'cz-gift', data: { source: 'cz-gift', itemCount: cart.item_count, deferDrawerOpen: true } };
      document.dispatchEvent(ev);
    }).catch(function () {});
  });
})();

/* Cosmelia – Reservierungs-Timer im Warenkorb (10 Min., läuft pro Sitzung) */
(function () {
  if (window.__czTimer) return; window.__czTimer = true;
  var KEY = 'cz_cart_deadline', MIN = 10;
  function deadline() {
    var d = 0; try { d = Number(sessionStorage.getItem(KEY)) || 0; } catch (e) {}
    if (!d || d < Date.now()) { d = Date.now() + MIN * 60000; try { sessionStorage.setItem(KEY, String(d)); } catch (e) {} }
    return d;
  }
  function tick() {
    var els = document.querySelectorAll('[data-cz-timer-display]'); if (!els.length) return;
    var s = Math.max(0, Math.round((deadline() - Date.now()) / 1000));
    var txt = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
    els.forEach(function (el) { el.textContent = txt; });
  }
  tick(); setInterval(tick, 1000);
})();

/* Cosmelia – Geschenk entfernen, wenn die Bundle-Bedingung nicht mehr erfüllt ist (_cz_gift_guard) */
(function () {
  var busy = false;
  document.addEventListener('cart:update', function (e) {
    var d = e.detail || {};
    if (busy || d.sourceId === 'cz-gift-guard') return;
    busy = true;
    setTimeout(function () {
      fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
        var fix = null;
        cart.items.forEach(function (it) {
          var pr = it.properties || {}; if (!pr._cz_gift_for || fix) return;
          var pid = Number(pr._cz_gift_for), min = Number(pr._cz_gift_min || 1), qty = 0;
          cart.items.forEach(function (x) { if (x.product_id === pid && !(x.properties || {})._cz_gift_for) qty += x.quantity; });
          if (qty < min) fix = { id: it.key, quantity: 0 };
          else if (it.quantity > 1) fix = { id: it.key, quantity: 1 };
        });
        if (!fix) return null;
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(fix) })
          .then(function (r) { return r.json(); }).then(function (c) {
            var ev = new Event('cart:update', { bubbles: true });
            ev.detail = { resource: c, sourceId: 'cz-gift-guard', data: { source: 'cz-gift-guard', itemCount: c.item_count } };
            document.dispatchEvent(ev);
          });
      }).catch(function () {}).then(function () { busy = false; });
    }, 400);
  });
})();

/* Cosmelia – Vorschau-Link: ?cz_preview=1 zeigt Beispielbewertungen nur für dich (bis Browser geschlossen), ?cz_preview=0 beendet */
(function () {
  var on = false;
  try {
    var q = new URLSearchParams(location.search).get('cz_preview');
    if (q === '1') sessionStorage.setItem('cz_preview', '1');
    if (q === '0') sessionStorage.removeItem('cz_preview');
    on = sessionStorage.getItem('cz_preview') === '1';
  } catch (e) {}
  if (!on) return;
  var html = document.documentElement; html.classList.remove('cz-live');
  function badge() {
    if (document.getElementById('cz-preview-badge')) return;
    var b = document.createElement('a'); b.id = 'cz-preview-badge'; b.href = '?cz_preview=0';
    b.textContent = 'Aperçu : avis exemples visibles (toi seule) · Quitter';
    b.style.cssText = 'position:fixed;left:12px;bottom:12px;z-index:99999;background:#111;color:#fff;font:500 12px/1 Jost,sans-serif;padding:10px 12px;text-decoration:none';
    document.body.appendChild(b);
  }
  if (document.body) badge(); else document.addEventListener('DOMContentLoaded', badge);
})();
